// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1VI9q","form":"styles_form__2iLwZ"};